const p = {
  id: 6,
  title: "EXPEDITION",
  subtitle: "HUCULSZCZYZNA 2019",
  details: {
    fullname:
      "21st Scientific Expedition of Architecture Students of Lodz University of Technology to the Eastern Carpathians in Ukraine – “THE HUTSUL LANDS 2019”",
    type: "scientific expedition -> conferences -> publication -> 1st place in nationwide competition as the best students' expedition of 2019",
    date: "07.2019",
    co_authors: "Scientific Architecture circle IX„Piętro”",
  },
  split1: {
    img: "Hucu/Main1.jpg",
    desc: [
      "The main goal of the expedition was to create technical architectural and construction documentation of historic wooden churches in the Eastern Carpathians.",
      "This is extremely important because the churches we measure do not have drawings that, if the building is destroyed, would be a testimony to them and could be used for conservation purposes.",
      "After the expedition, I made drawings of the church in Rusów. Together with the academic circle, we presented the expedition at conferences and the StRuNa 2019 competition for the best scientific projects of students and doctoral students, where it won the first place in the expedition of the year category.",
    ],
  },
  split2: {
    img: "Hucu/Main2.jpg",
    desc: [
      "Sample drawing of the church -plan",
      "Full documentation included notes and photos taken at the measurement site as well as a plan, 2 sections and 4 elevations made upon return.",
    ],
  },
  imgs: [
    {
      title: "Photo by Gabriela Potoniec",
      src: "Hucu/Gallery/Photo by Gabriela Potoniec (2).jpg",
    },
    {
      title: "Photo by Gabriela Potoniec",
      src: "Hucu/Gallery/Photo by Gabriela Potoniec.jpg",
    },
    {
      title: "Photo by Roksana Nowicka",
      src: "Hucu/Gallery/Photo by Roksana Nowicka.jpg",
    },
    {
      title: "Photo by Wojciech Pardała",
      src: "Hucu/Gallery/Photo by Wojciech Pardała.jpg",
    },
    {
      title: "Sketch of the building",
      src: "Hucu/Gallery/Sketch of the building.jpg",
    },
    {
      title: "Sketch",
      src: "Hucu/Gallery/Sketch.jpg",
    },
  ],
};

export default p;
